

export var GlobalVariables = {
    storagePrefix: 'flx-',
    get: function (key) {
        let internalVar = this['_' + key];
        if (internalVar) return internalVar;

        return window.localStorage.getItem(this.storagePrefix + key);
    },
    set: function (key, value) {
        let internalVar = this['_' + key];
        window.localStorage.setItem(this.storagePrefix + key, value);

        this[internalVar] = value;
    },
    clearStorage: function () {
        let itemsKey = [];

        for (let i = 0; i < localStorage.length; i++) {
            if (localStorage.key(i).substring(0, this.storagePrefix.length) == this.storagePrefix) {
                itemsKey.push(localStorage.key(i));
            }
        }

        itemsKey.forEach(key => {
            localStorage.removeItem(key);
        });
    },
    get accessToken() {
        return this.get('accessToken');
    },
    set accessToken(value) {
        this.set('accessToken', value);
    },
    get accessType() {
        return this.get('accessType');
    },
    set accessType(value) {
        this.set('accessType', value);
    },
    get authToken() {
        return this.get('authToken');
    },
    set authToken(value) {
        this.set('authToken', value);
    },
    get username() {
        return this.get('username');
    },
    set username(value) {
        this.set('username', value);
    },
    get role() {
        return this.get('role');
    },
    set role(value) {
        this.set('role', value);
    },
    get passwordPolicies() {
        return this.get('passwordPolicies');
    },
    set passwordPolicies(value) {
        this.set('passwordPolicies', value);
    },
    amountRequested: 10,
    pages: {
        adminUsers: {
            link: 'admin-users',
            text: 'Admin users'
        },
        adminUsersDetail: {
            link: 'admin-users-detail',
            text: 'User account'
        },
        home: {
            link: 'home',
            text: 'Home'
        },
        login: {
            link: 'login',
            text: 'Login'
        },
        userAccount: {
            link: 'user-account'
        },
        apiDocs: {
            link: 'api-docs',
            text: 'Api Docs',
        },
        extensions: {
            link: 'home',
            text: 'E-commerce extensions',
            childs: ['ext-magento-1', 'ext-magento-2']
        },
        extMagento1: {
            link: 'ext-magento-1',
            text: 'Magento 1'
        },
        extMagento2: {
            link: 'ext-magento-2',
            text: 'Magento 2'
        },
        sdk: {
            link: 'home',
            text: 'SDK',
            childs: ['sdk-javascript']
        },
        sdkJavascript: {
            link: 'sdk-javascript',
            text: 'Javascript'
        },
        sandbox: {
            link: 'sandbox',
            text: 'Sandbox'
        }
    }
};


// WEBPACK FOOTER //
// ./src/variables/global.ts